export enum LogLevel {
    Debug,
    Info,
    Warning,
    Error,
    Critical,
}
